
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/feature/SEOHead';

export default function RegionsPage() {
  const regions = [
    {
      id: 1,
      name: "香港",
      subtitle: "Hong Kong",
      description: "国际化的品质标准与严格的质量管控体系，确保每一款产品都达到世界级水准。融合东西方医学精华，为现代养生注入科学理念。",
      image: "https://public.readdy.ai/ai/img_res/f47175b98c35e50b3cd8d6476f8a94ef.jpg",
      features: ["国际标准", "质量管控", "科学理念", "现代工艺"],
      specialties: [
        {
          name: "质量认证体系",
          description: "严格按照国际GMP标准生产",
          icon: "ri-shield-check-line"
        },
        {
          name: "现代化工艺",
          description: "融合传统智慧与现代科技",
          icon: "ri-settings-3-line"
        },
        {
          name: "国际化视野",
          description: "汇聚全球优质资源",
          icon: "ri-global-line"
        }
      ],
      color: "#2f3673",
      bgColor: "from-blue-50 to-indigo-50"
    },
    {
      id: 2,
      name: "云南",
      subtitle: "Yunnan",
      description: "得天独厚的地理环境孕育出珍贵的道地药材，千年传承的种植工艺确保药材品质。高原净土，天然无污染，是大自然的馈赠。",
      image: "https://readdy.ai/api/search-image?query=Beautiful%20Yunnan%20mountain%20landscape%20with%20traditional%20Chinese%20herbal%20medicine%20gardens%2C%20terraced%20fields%20of%20medicinal%20plants%2C%20misty%20mountains%20in%20background%2C%20natural%20pristine%20environment%2C%20representing%20authentic%20traditional%20medicine%20cultivation&width=600&height=400&seq=yn-001&orientation=landscape",
      features: ["道地药材", "天然环境", "传统工艺", "高原净土"],
      specialties: [
        {
          name: "道地药材基地",
          description: "千年传承的药材种植区域",
          icon: "ri-plant-line"
        },
        {
          name: "生态环境",
          description: "高原净土，无污染种植",
          icon: "ri-leaf-line"
        },
        {
          name: "传统工艺",
          description: "古法种植与现代管理结合",
          icon: "ri-ancient-gate-line"
        }
      ],
      color: "#8b5a3c",
      bgColor: "from-amber-50 to-orange-50"
    },
    {
      id: 3,
      name: "泰国",
      subtitle: "Thailand",
      description: "热带雨林中的天然草本宝库，丰富的生物多样性造就了独特的草本资源。传统泰式养生智慧与现代提取技术完美融合。",
      image: "https://readdy.ai/api/search-image?query=Lush%20Thai%20tropical%20rainforest%20with%20traditional%20herbal%20plants%2C%20golden%20temple%20architecture%20in%20background%2C%20natural%20botanical%20garden%20with%20exotic%20medicinal%20herbs%2C%20representing%20traditional%20Thai%20wellness%20wisdom%20and%20natural%20abundance&width=600&height=400&seq=th-001&orientation=landscape",
      features: ["热带草本", "生物多样性", "传统智慧", "天然提取"],
      specialties: [
        {
          name: "热带草本",
          description: "丰富的热带药用植物资源",
          icon: "ri-seedling-line"
        },
        {
          name: "传统智慧",
          description: "千年泰式养生文化传承",
          icon: "ri-book-open-line"
        },
        {
          name: "天然提取",
          description: "先进的植物精华提取技术",
          icon: "ri-flask-line"
        }
      ],
      color: "#f7931d",
      bgColor: "from-orange-50 to-amber-50"
    }
  ];

  const advantages = [
    {
      icon: "ri-award-line",
      title: "三地融合",
      description: "汇聚香港、云南、泰国三地精华，打造独特配方"
    },
    {
      icon: "ri-shield-check-line",
      title: "品质保证",
      description: "严格的质量控制体系，确保每一份产品的安全有效"
    },
    {
      icon: "ri-leaf-line",
      title: "天然纯正",
      description: "选用天然优质原料，无添加剂，安全可靠"
    },
    {
      icon: "ri-global-line",
      title: "国际标准",
      description: "按照国际标准生产，品质达到世界先进水平"
    }
  ];

  const regionsSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "三地精粹 - 狮虎堂原料产地",
    "description": "探索狮虎堂产品的三大原料产地：香港的现代工艺、云南的道地药材、泰国的天然草本，了解我们如何融汇三地精粹。",
    "url": `${import.meta.env.VITE_SITE_URL}/regions`,
    "mainEntity": {
      "@type": "ItemList",
      "numberOfItems": 3,
      "itemListElement": [
        {
          "@type": "Place",
          "position": 1,
          "name": "香港",
          "description": "现代工艺与传统智慧的完美结合"
        },
        {
          "@type": "Place",
          "position": 2,
          "name": "云南",
          "description": "道地药材的天然宝库"
        },
        {
          "@type": "Place",
          "position": 3,
          "name": "泰国",
          "description": "天然草本的神秘力量"
        }
      ]
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="三地精粹 - 狮虎堂原料产地探索"
        description="探索狮虎堂产品的三大原料产地：香港的现代工艺、云南的道地药材、泰国的天然草本，了解我们如何融汇三地精粹。"
        keywords="三地精粹,香港工艺,云南药材,泰国草本,原料产地,中草药来源"
        ogImage="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/f35a59635442fe291a9bbc6026c2854c.jfif"
        schema={regionsSchema}
      />
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative py-20 overflow-hidden">
          <div 
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url('https://readdy.ai/api/search-image?query=Panoramic%20view%20combining%20Hong%20Kong%20skyline%2C%20Yunnan%20mountains%2C%20and%20Thai%20tropical%20landscape%20in%20artistic%20blend%2C%20representing%20three%20regions%20unity%2C%20professional%20photography%2C%20golden%20hour%20lighting%2C%20harmonious%20composition%20showing%20cultural%20and%20natural%20diversity&width=1200&height=600&seq=hero-regions&orientation=landscape')`
            }}
          ></div>
          <div className="absolute inset-0 bg-gradient-to-r from-[#2f3673]/90 to-[#2f3673]/70"></div>
          
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
            <h1 className="text-xl md:text-2xl font-bold text-white mb-6">三地精粹</h1>
            <p className="text-sm md:text-base text-white/90 max-w-3xl mx-auto mb-8">
              融汇香港国际标准、云南道地药材、泰国天然草本
              <br />
              三地精华汇聚，为您打造卓越的养生体验
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <div className="flex items-center space-x-1 text-white">
                <i className="ri-map-pin-line text-[#f7931d] text-sm"></i>
                <span className="text-xs font-medium">香港品质</span>
              </div>
              <div className="flex items-center space-x-1 text-white">
                <i className="ri-plant-line text-[#f7931d] text-sm"></i>
                <span className="text-xs font-medium">云南药材</span>
              </div>
              <div className="flex items-center space-x-1 text-white">
                <i className="ri-leaf-line text-[#f7931d] text-sm"></i>
                <span className="text-xs font-medium">泰国草本</span>
              </div>
            </div>
          </div>
        </section>

        {/* Regions Section */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-xl md:text-2xl font-bold text-[#2f3673] mb-4">
                三地精粹 · 各具特色
              </h2>
              <p className="text-sm md:text-base text-gray-600 max-w-3xl mx-auto">
                每一个地区都有其独特的优势和特色，我们将这些精华完美融合，
                为您带来前所未有的养生体验
              </p>
            </div>

            <div className="space-y-20">
              {regions.map((region, index) => (
                <div key={region.id} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
                  {/* Image */}
                  <div className={`${index % 2 === 1 ? 'lg:col-start-2' : ''}`}>
                    <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                      <img
                        src={region.image}
                        alt={region.name}
                        className="w-full h-80 object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                      <div className="absolute bottom-6 left-6">
                        <div className="flex items-center space-x-2">
                          <div 
                            className="w-3 h-3 rounded-full"
                            style={{ backgroundColor: region.color }}
                          ></div>
                          <span className="text-white font-medium text-sm">{region.name}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className={`${index % 2 === 1 ? 'lg:col-start-1' : ''}`}>
                    <div className={`bg-gradient-to-br ${region.bgColor} p-8 rounded-2xl`}>
                      <div className="mb-6">
                        <h3 className="text-lg font-bold mb-2" style={{ color: region.color }}>
                          {region.name}
                        </h3>
                        <p className="text-xs text-gray-500 font-medium mb-4">
                          {region.subtitle}
                        </p>
                        <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                          {region.description}
                        </p>
                      </div>

                      {/* Features */}
                      <div className="flex flex-wrap gap-2 mb-6">
                        {region.features.map((feature, featureIndex) => (
                          <span
                            key={featureIndex}
                            className="px-3 py-1 rounded-full text-xs font-medium"
                            style={{ 
                              backgroundColor: `${region.color}20`,
                              color: region.color 
                            }}
                          >
                            {feature}
                          </span>
                        ))}
                      </div>

                      {/* Specialties */}
                      <div className="space-y-4">
                        {region.specialties.map((specialty, specialtyIndex) => (
                          <div key={specialtyIndex} className="flex items-start space-x-3">
                            <div 
                              className="w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0"
                              style={{ backgroundColor: `${region.color}20` }}
                            >
                              <i 
                                className={`${specialty.icon} text-sm`}
                                style={{ color: region.color }}
                              ></i>
                            </div>
                            <div>
                              <h4 className="text-xs font-semibold text-gray-900 mb-1">
                                {specialty.name}
                              </h4>
                              <p className="text-xs text-gray-600">
                                {specialty.description}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Advantages Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-xl md:text-2xl font-bold text-[#2f3673] mb-4">
                三地融合 · 独特优势
              </h2>
              <p className="text-sm md:text-base text-gray-600 max-w-3xl mx-auto">
                将三地的独特优势完美结合，为您提供更加全面和有效的养生解决方案
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-4xl mx-auto">
              {advantages.map((advantage, index) => (
                <div key={index} className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#f7931d] to-[#e6841a] rounded-xl flex items-center justify-center mb-4">
                    <i className={`${advantage.icon} text-white text-lg`}></i>
                  </div>
                  <h3 className="text-sm font-bold text-[#2f3673] mb-2">
                    {advantage.title}
                  </h3>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    {advantage.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-[#2f3673] to-[#f7931d]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-xl md:text-2xl font-bold text-white mb-4">
              体验三地精粹的神奇力量
            </h2>
            <p className="text-sm md:text-base text-white/90 mb-8 max-w-2xl mx-auto">
              让香港的品质标准、云南的道地药材、泰国的天然草本
              为您的健康保驾护航
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => window.REACT_APP_NAVIGATE('/products')}
                className="bg-white text-[#2f3673] px-8 py-3 rounded-full text-sm font-semibold hover:bg-gray-100 transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                查看产品系列
              </button>
              <button 
                onClick={() => window.REACT_APP_NAVIGATE('/about')}
                className="border-2 border-white text-white px-8 py-3 rounded-full text-sm font-semibold hover:bg-white hover:text-[#2f3673] transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                了解更多故事
              </button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
